import * as vuelidate from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'
import { Validator } from '@/shared/forms/validator'
import { validatorMapping } from '@hakla/typed-forms'
import { htmlToText } from '@/shared/utils/html-to-text'
import { isNotBlank } from '@/shared/utils/is-blank'
import { isAfter, isBefore, parse } from 'date-fns'
import { StringMap } from '@/shared/utils/map'

const patternValidator = (expression: RegExp) => vuelidate.helpers.regex('pattern', expression)

export const vuelidateMapping = validatorMapping<Validator>({
  $each(validations: StringMap<any>): Validator {
    return validations as any
  },

  between(min: number, max: number): Validator {
    return vuelidate.between(min, max)
  },

  dateAfter(other: string): Validator {
    return ((value: string, form: any) => {
      let valid = true

      const fromRaw = value
      const untilRaw = form[other]

      if (isNotBlank(fromRaw) && isNotBlank(untilRaw)) {
        const from = parse(fromRaw, 'HH:mm', 0)
        const until = parse(untilRaw, 'HH:mm', 0)

        if (isNaN(from.getTime()) === false && isNaN(until.getTime()) === false) {
          valid = isAfter(from, until)
        }
      }

      return valid
    }) as any
  },

  dateBefore(other: string): Validator {
    return ((value: string, form: any) => {
      let valid = true

      const fromRaw = value
      const untilRaw = form[other]

      if (isNotBlank(fromRaw) && isNotBlank(untilRaw)) {
        const from = parse(fromRaw, 'HH:mm', 0)
        const until = parse(untilRaw, 'HH:mm', 0)

        if (isNaN(from.getTime()) === false && isNaN(until.getTime()) === false) {
          valid = isBefore(from, until)
        }
      }

      return valid
    }) as any
  },

  email() {
    return vuelidate.email
  },

  max(max: number): Validator {
    return vuelidate.maxValue(max)
  },

  maxLength(maxLength: number): Validator {
    return vuelidate.maxLength(maxLength)
  },

  maxLengthHtml(length: number): Validator {
    return helpers.withParams(
      {
        max: length,
        type: 'maxLengthHtml',
      },
      (value: string) => htmlToText(value).length < length
    )
  },

  min(min: number): Validator {
    return vuelidate.minValue(min)
  },

  minLength(minLength: number): Validator {
    return vuelidate.minLength(minLength)
  },

  pattern(pattern: RegExp): Validator {
    return patternValidator(pattern)
  },

  required(): Validator {
    return vuelidate.required
  },

  sameAs(control: string): Validator {
    return vuelidate.sameAs(control)
  },
})
